// ============================================================
// PREZENCE — Consent Report (admin/HR)
// Shows who has / hasn't acknowledged the current monitoring policy.
// ============================================================
import React, { useState, useEffect } from 'react';
import api from '../../api/client';
import toast from 'react-hot-toast';
import './consentReport.css';

export default function ConsentReport() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/consent/report')
      .then(r => setData(r.data))
      .catch(() => toast.error('Failed to load consent report'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="cr-loading"><div className="spinner" /></div>;
  if (!data) return null;

  const pct = data.total ? Math.round(data.consented / data.total * 100) : 0;

  return (
    <div className="cr-root">
      <div className="cr-header">
        <h1 className="cr-title">Consent Report</h1>
        <p className="cr-sub">Monitoring policy acknowledgment · version {data.currentVersion}</p>
      </div>

      <div className="cr-stats">
        <div className="cr-stat">
          <div className="cr-stat-val" style={{ color: '#63dcbc' }}>{data.consented}</div>
          <div className="cr-stat-label">ACKNOWLEDGED</div>
        </div>
        <div className="cr-stat">
          <div className="cr-stat-val" style={{ color: '#f59e0b' }}>{data.pending}</div>
          <div className="cr-stat-label">PENDING</div>
        </div>
        <div className="cr-stat">
          <div className="cr-stat-val">{pct}%</div>
          <div className="cr-stat-label">COVERAGE</div>
        </div>
      </div>

      <div className="cr-panel">
        <table className="cr-table">
          <thead>
            <tr><th>Employee</th><th>Department</th><th>Status</th><th>Acknowledged</th></tr>
          </thead>
          <tbody>
            {data.users.map(u => (
              <tr key={u.id}>
                <td className="cr-name">{u.full_name}</td>
                <td className="cr-dept">{u.department || '—'}</td>
                <td>
                  {u.consented
                    ? <span className="cr-badge cr-yes">✓ Acknowledged</span>
                    : <span className="cr-badge cr-no">Pending</span>}
                </td>
                <td className="cr-date">
                  {u.consentedAt ? new Date(u.consentedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
